'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { attachSubComponents, InternalProvider, usePropDeprecation } from '../../util';
import { PriceContext } from './PriceContext';
import { Cost } from './Cost';
import { Container, Super } from './elements';
import { SupportiveText } from './SupportiveText';
import { InfoAction, InfoIcon } from './InfoIcon';
import { SimpleBlockContext } from '../SimpleBlock/SimpleBlockContext';
const simpleBlockToPriceSize = {
  sm: 'sm',
  md: 'sm',
  lg: 'md',
  xl: 'lg'
};
export const Price = attachSubComponents('Price', /*#__PURE__*/React.forwardRef(({
  size,
  alignment,
  children,
  ...rest
}, fRef) => {
  const {
    size: simpleBlockSize,
    contentHeight: simpleBlockContentHeight
  } = useContext(SimpleBlockContext);
  usePropDeprecation({
    name: 'Price.alignment',
    value: alignment,
    version: 'v5.0.0'
  });
  if (!size && simpleBlockSize) {
    size = simpleBlockToPriceSize[simpleBlockSize];
  } else if (!size) size = 'md'; // default to md size for price

  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(PriceContext.Provider, {
    value: {
      size
    }
  }, /*#__PURE__*/React.createElement(Container, _extends({
    "data-aui": "price",
    $alignment: alignment ?? 'stack',
    $shouldGrow: simpleBlockContentHeight === 'fill',
    ref: fRef
  }, rest), children)));
}), {
  Cost,
  Super,
  SupportiveText,
  /** @deprecated */
  InfoIcon,
  InfoAction
});